import * as React from "react";

import Button from "@replo/design-system/components/button/Button";
import { FileText } from "lucide-react";

type NoDataProps = {
  resetAll: () => void;
};

export const NoData: React.FC<NoDataProps> = ({ resetAll }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <FileText className="text-muted text-5xl" />
      <div className="flex flex-col items-center justify-center gap-2">
        <div className="header-h4">No matching pages</div>
        <div className="text-muted text-base">
          Try adjusting your filters or search term.
        </div>
        <Button variant="secondary" size="base" onClick={resetAll}>
          Reset filters
        </Button>
      </div>
    </div>
  );
};
